import React from 'react';
import PropTypes from 'prop-types';

import clsx from 'clsx';
import { withStyles } from '@eGroupTeam/material';

const styles = (theme) => ({
  root: {
    textAlign: 'right',
    padding: theme.spacing(2),
    paddingTop: 0,
  },
  /* Styles applied to the root element if `disableSpacing={false}`. */
  spacing: {
    '& > :not(:first-child)': {
      marginLeft: 8,
    },
  },
});

const IntroduceCardActions = React.forwardRef((props, ref) => {
  const { disableSpacing = false, classes, className, ...other } = props;

  return (
    <div
      className={clsx(
        classes.root,
        { [classes.spacing]: !disableSpacing },
        className
      )}
      ref={ref}
      {...other}
    />
  );
});

IntroduceCardActions.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the actions do not have additional margin.
   */
  disableSpacing: PropTypes.bool,
};

export default withStyles(styles)(IntroduceCardActions);
